export const getCarsSelector = store => {
    return store.getIn(['cars', 'cars'])
}

export const getCarsCountSelector = store => {
    return store.getIn(['cars', 'carsCount'])
}
